/**
 * Contador de requisições em voo — o sinal objetivo de "a tela terminou de
 * carregar".
 *
 * POR QUE NÃO UM TIMER SIMPLES
 * Um contador de 20s a partir da navegação erra justamente nas telas pesadas:
 * consolidador e comissões passam segundos buscando dados, e o card apareceria
 * sobre um esqueleto de carregamento. A nota mediria o loader, não o módulo.
 *
 * POR QUE NÃO PERGUNTAR AO MÓDULO
 * Exigiria que cada módulo avisasse "terminei" — trabalho em N lugares, que
 * envelhece mal e quebra em silêncio quando alguém esquece.
 *
 * O interceptor é registrado por ESTE módulo no boot, sem alterar
 * `plugins/axios.js`.
 *
 * POLLING: rotas que ficam consultando em segundo plano (atualização de bancos,
 * cotização) nunca deixariam o contador zerar. Elas entram em IGNORADAS.
 */
import api from '@plugins/axios'

const IGNORADAS = [
  'crawler',
  'atualizando',
  'cotizacao',
  'notificacoes',
  'websocket',
  '/nps/',
]

let emVoo = 0
let registrado = false

function deveIgnorar(url) {
  if (!url) return true
  return IGNORADAS.some((trecho) => url.includes(trecho))
}

export function registrarInterceptor(instancia) {
  const alvo = instancia || api
  if (registrado) return
  registrado = true

  alvo.interceptors.request.use(
    function (config) {
      if (config && !deveIgnorar(config.url)) {
        emVoo = emVoo + 1
        config.__npsContado = true
      }
      return config
    },
    function (erro) {
      return Promise.reject(erro)
    }
  )

  alvo.interceptors.response.use(
    function (resposta) {
      if (resposta && resposta.config && resposta.config.__npsContado) {
        emVoo = Math.max(0, emVoo - 1)
      }
      return resposta
    },
    function (erro) {
      if (erro && erro.config && erro.config.__npsContado) {
        emVoo = Math.max(0, emVoo - 1)
      }
      return Promise.reject(erro)
    }
  )
}

export function requisicoesEmVoo() {
  return emVoo
}

/** Usado só por teste. */
export function _reset() {
  emVoo = 0
  registrado = false
}
